export default "__VITE_ASSET__Bd$N5uZw__"